export enum ListType {
  INFINITE_SCROLL = 'INFINITE_SCROLL',
  PAGINATION = 'PAGINATION',
}
